import { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import infoIcon from "../../../assets/images/infobtnblue.svg";
import SubmitLoading from "../../../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../../../component/common-component/Loaders/MainpageLoader";
import { commonservices } from "../../../services/CommonServices";
import { toast } from "react-toastify";
import PaymentMethodSelection from "../../PaymentMethodSelection";

const TopupModal = ({ show, onHide, walletId, onPaymentSuccess }) => {
  const [Loading, setLoading] = useState(false);
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);

  const [input, setInput] = useState({
    amount: "",
    // paymentMethod: "",
    errors: {
      amount: "",
      // paymentMethod: "",
      ValidationRules: [
        {
          FieldName: "amount",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        // {
        //   FieldName: "paymentMethod",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
      ],
    },
  });

  const sanitizeNumber = (str) => str.replace(/\D/g, "");

  const sanitizeFloat = (str) => {
    // 1. Keep digits and dots only
    let cleaned = str.replace(/[^0-9.]/g, "");
    // 2. Ensure at most one dot
    const parts = cleaned.split(".");
    if (parts.length > 2) {
      cleaned = parts[0] + "." + parts.slice(1).join("");
    }
    return cleaned;
  };

  const fnInputChange = (value, tag) => {
    let onlyNumber = false
    let allowFloat = true

    let val = value;
    if (onlyNumber && !allowFloat) {
      // Integers only (remove non‑digits)
      val = sanitizeNumber(val);
    } else if (allowFloat) {
      // Digits + single ".", allow leading "."
      val = sanitizeFloat(val);
    }

    setInput({
      ...input,
      [tag]: val,
      errors: {
        ...input.errors,
        [tag]: "",
      },
    });
  };

  const fnCreateTopupPayment = async (e) => {
    e?.preventDefault()
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      if (parseFloat(input?.amount) < 1) {
        return toast.error("Please enter an amount of at least $1.");
      }
      setShowPaymentPopup(true);
    }
  };

  useEffect(() => {
    const cleanup = commonservices.setupKeyPressHandler(fnCreateTopupPayment);
    return cleanup;
  }, [fnCreateTopupPayment]);

  return (
    <>
    <Modal
      show={show && !showPaymentPopup}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      {Loading && <MainpageLoader />}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Top-Up
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <Form.Group className="form-group">
              <Form.Label className="login-label">
                Amount($)<span className="ms-1 red-color-text">*</span>
              </Form.Label>
              <div className="position-relative">
                <Form.Control
                  type="text"
                  maxLength={10}
                  placeholder="Amount"
                  className="common-input"
                  value={input.amount}
                  onChange={(e) =>
                    fnInputChange(e.target.value, "amount")
                  }
                  isInvalid={input?.errors?.amount}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                    }
                  }}
                />
                {input.errors.amount && (
                  <Form.Control.Feedback type="invalid">
                    <span className="error-message-icon">
                      <img
                        src={infoIcon}
                        alt="infoIcon"
                        title={input.errors.amount}
                      />
                    </span>
                  </Form.Control.Feedback>
                )}
              </div>
            </Form.Group>
          </Col>
 
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button className="grey-btn w-auto" onClick={onHide}>
          Close
        </button>
        <button disabled={Loading} className="blue-btn w-auto" onClick={fnCreateTopupPayment}>
          {Loading ? (
            <SubmitLoading />
          ) : (
            "Submit"
          )}
        </button>
      </Modal.Footer>
    </Modal>
    {showPaymentPopup && (
      <PaymentMethodSelection
        show={showPaymentPopup}
        item={{
          invoicefinalamount: parseFloat(input?.amount || 0).toFixed(2),
          walletid: walletId,
        }}
        itemtype="Wallet"
        returnpath="/management-listing"
        onPaymentSuccess={() => {
          setShowPaymentPopup(false);
          if (onPaymentSuccess) {
            onPaymentSuccess();
          }
          onHide();
        }}
        onHide={() => setShowPaymentPopup(false)}
      />
    )}
    </>
  );
};

export default TopupModal;
